import React from "react";

import Start from "../components/Start";
import Customers from "../components/Customers";
import Offer from "../components/Offer";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

function StartPage() {
  return (
    <>
      <Start />
      <Customers />
      <Offer />
      <About />
      <Contact />
      <Footer />
    </>
  );
}

export default StartPage;
